import React from 'react';
import styled from 'styled-components';

interface UserSettingsRequestsTabProps {
  userId?: string;
}

const UserSettingsRequestsTab: React.FC<UserSettingsRequestsTabProps> = ({ userId }) => {
  return (
    <Container>
      <PlaceholderText>My Requests Content - Coming Soon</PlaceholderText>
    </Container>
  );
};

const Container = styled.div`
  padding: 1rem 0;
`;

const PlaceholderText = styled.p`
  font-size: 1rem;
  color: ${(props) => props.theme.colors.primaryBlack70};
`;

export default UserSettingsRequestsTab;
